module.exports = __webpack_public_path__ + "static/fast-food-nation-1ba091ba495b773ac04508d247885f66.jpg";